import { html, LitElement, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getMacroLiteraryDesignVisual } from "../../data/visuals";

import styles from "./viz-macro-literary-design.css";

import type { MacroLiteraryDesignVisualData } from "../../types";
import type { PropertyValues } from "lit";

@customElement("bp-viz-macro-literary-design")
export class VizMacroLiteraryDesign extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: MacroLiteraryDesignVisualData;

  render() {
    if (!this.data) return nothing;

    const { config, caption } = this.data;

    return html`
      <div class="container">
        <bp-macro-literary-design .data=${config} />
      </div>
      ${caption &&
      html` <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption> `}
    `;
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getMacroLiteraryDesignVisual(this.arcId)
      .then(({ data }) => {
        this.data = data;
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-macro-literary-design": VizMacroLiteraryDesign;
  }
}
